import React, { useEffect } from 'react'
import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import queryString from 'query-string'

import ChipNew from '../common/ChipNew'
import {
  publishClickedHomeInviteMembers,
  publishClickedJoinOrCreateTeam,
  publishViewedHomePromo,
  publishViewedHomeTeam,
} from '../../util/events/teamsOnboardingEventPublishers'
import { selectUserTeam } from '../../redux/selectors/userTeamSelectors'

const formatMemberName = ({ firstName, lastName, email }) =>
  Boolean(firstName) && Boolean(lastName) ? `${firstName} ${lastName}` : email

const HomeTeams = ({ isWebpSupported }) => {
  const userTeam = useSelector(selectUserTeam)
  const dispatch = useDispatch()

  const hasTeam = Boolean(userTeam?.team)

  const handleOpenCreateDialog = () => {
    publishClickedJoinOrCreateTeam()
    dispatch(push({ search: queryString.stringify({ createTeam: true }) }))
  }

  const handleOpenInviteDialog = () => {
    publishClickedHomeInviteMembers()
    dispatch(push({ search: queryString.stringify({ inviteMembers: true }) }))
  }

  useEffect(() => {
    if (hasTeam) {
      publishViewedHomeTeam()
    } else {
      publishViewedHomePromo()
    }
  }, [hasTeam])

  return (
    <>
      <Box paddingRight={4}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Typography variant="h6">Your team</Typography>&nbsp;
          {!hasTeam && <ChipNew />}
        </Box>

        {!hasTeam && (
          <Typography gutterBottom>
            Is your team on Foodsby? Get exclusive discounts and offers.
          </Typography>
        )}

        {hasTeam && (
          <List>
            {userTeam.team.membersPreview.map((member, key) => (
              <ListItem key={key}>
                <ListItemAvatar>
                  <Avatar
                    src={
                      member.avatarId &&
                      `${process.env.REACT_APP_IMAGE_LAMBDA}/profiles/${member.avatarId}.${
                        isWebpSupported ? 'webp' : 'jpeg'
                      }?height=50&width=50`
                    }
                  />
                </ListItemAvatar>
                <ListItemText primary={formatMemberName(member)} />
              </ListItem>
            ))}
          </List>
        )}

        {!hasTeam && (
          <Button color="primary" onClick={handleOpenCreateDialog}>
            + Create or join a team
          </Button>
        )}

        {hasTeam && (
          <Button color="primary" onClick={handleOpenInviteDialog}>
            + Invite team members
          </Button>
        )}
      </Box>
    </>
  )
}

export default HomeTeams
